import axios from 'axios';

const API_BASE = (process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api/v1').replace(/\/+$/, '');

const publicApi = axios.create({ baseURL: API_BASE });

export const validateUploadLink = (token) =>
  publicApi.get(`/secure-uploads/portal/${token}/`);

export const submitBatch = (token, formData, onUploadProgress) =>
  publicApi.post(`/secure-uploads/portal/${token}/submit/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress,
  });
